import React from 'react';
import { PASSWORD_GENERATOR_URL } from '@/config/urls/passwordUrls';

const vpsOci = {
  myPlan: {
    reboot: 'Reiniciar',
    rebootModal: {
      title: 'Reiniciar máquina (reboot)',
      message: productName => (
        <>
          <div>
            Você tem certeza que deseja reiniciar a sua
            {' '}
            <strong>{productName}</strong>
            ?
          </div>
          <p>
            A reinicialização levará cerca de 15 minutos e durante esse período todos os seus serviços ficarão indisponíveis.
          </p>
        </>
      ),
      cancel: 'Cancelar',
      checkRebootHistory: 'Ver histórico de reboots',
      confirm: 'Sim, reiniciar agora',
    },
    rebootHistory: {
      title: 'Histórico de reboots',
      message: productName => (
        <>
          Últimas reinicializações da sua
          {' '}
          <strong>
            {productName}
          </strong>
          .
        </>
      ),
      date: 'Data',
      time: 'Horário',
      goBack: 'Voltar',
    },
    feedback: {
      loading: 'Pode fechar esta janela. O reinício segue em segundo plano... retorne em breve para acompanhar.',
      success: 'VPS reiniciado com sucesso!',
      error: 'Não foi possível reiniciar agora. Por favor, tente novamente mais tarde.',
    },
    tooltip: {
      favorite: 'Favoritar',
    },
    setServerNickname: 'Definir apelido do servidor',
  },
  status: {
    online: 'Online',
    offline: 'Offline',
    processing: 'Processando',
    rebuild: 'Rebuild solicitado',
    reboot: 'Reiniciando',
    passwordChange: 'Alterando senha',
    dockerManager: 'Gerenciando Docker',
    pending: 'Pendente',
    suspended: 'Suspenso',
    building: 'Em configuração',
  },
  infoVps: {
    title: {
      text: 'Informações da VPS',
      tooltip: 'Tudo o que identifica o seu servidor.',
    },
    domain: 'Domínio primário',
    serverIp: 'IP',
    serverIpMain: 'IP principal',
    serverIpSecondary: 'IP',
    datacenter: 'Localização do servidor',
    processor: 'Processador',
    memory: 'Memória RAM',
    disk: 'Armazenamento',
  },
  infoSsh: {
    title: {
      text: 'Acesso SSH',
      tooltip: 'Copie essas informações pra se conectar via SSH pelo terminal da sua preferência. É o caminho pra acessar diretamente o ambiente da sua VPS.',
    },
    serverIp: 'IP',
    serverPort: 'Porta',
    serverPortTooltip: 'A porta não sincroniza com alterações feitas via terminal/console. Se alterada manualmente, a exibida aqui pode não ser a porta real de acesso.',
    user: 'Usuário',
    password: 'Senha',
    changePassword: 'Alterar senha',
    changePasswordModal: {
      title: 'Trocar senha de acesso SSH',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar nova senha',
      passwordRequirements: 'Sua senha deve ter:',
      requirementUppercaseLowercase: 'Incluir caracteres maiúsculos e minúsculos',
      requirementNumber: 'Incluir pelo menos 1 número',
      requirementSymbol: 'Incluir pelo menos 1 símbolo',
      requirementLength: 'Ter pelo menos 8 caracteres',
      requirementMatch: 'Ser a mesma em ambos os campos',
      alertMessage: {
        text: 'Caso você tenha dificuldade para gerar uma senha forte e segura, veja nosso',
        link: {
          text: 'gerador de senhas.',
          href: PASSWORD_GENERATOR_URL,
        },
      },
      newInstallation: {
        title: 'Defina uma nova senha de acesso SSH',
        description: 'A instalação da sua VPS foi concluída! Agora, crie uma nova senha para acessar via SSH.',
      },
      cancel: 'Cancelar',
      save: 'Salvar senha',
      success: 'Senha de acesso SSH alterada!',
      error: 'Senha de acesso SSH não alterada. Por favor, tente novamente.',
    },
    terminal: {
      buttonLabel: 'Abrir console',
      modal: {
        error: {
          title: 'Erro ao abrir o console do navegador',
          message: 'Não foi possível carregar o console pelo navegador neste momento. Tente novamente mais tarde ou',
          link: {
            text: 'acesse sua VPS por outro console de sua preferência.',
            url: 'https://suporte.hostgator.com.br/hc/pt-br/articles/30812824748051-Como-acessar-um-servidor-via-SSH',
          },
          confirmButton: 'Entendi',
        },
      },
    },
  },
  management: {
    title: {
      text: 'SO, painel e aplicações',
      tooltip: 'Gerencie o sistema operacional, painel e aplicações instaladas na sua VPS. Aqui você pode visualizar a stack atual e realizar alterações quando necessário.',
    },
    currentOS: 'Sistema operacional atual:',
    changeSoApps: 'Alterar SO, painel ou aplicações',
    items: [
      {
        slug: 'so-apps',
        name: 'SO e aplicações',
      },
      {
        slug: 'backup',
        name: 'Backup',
        info: 'Último backup: ',
      },
      {
        slug: 'snapshot',
        name: 'Snapshot',
        info: 'Último snapshot: ',
      },
      {
        slug: 'ssh-keys',
        name: 'Chaves SSH',
      },
      {
        slug: 'n8n',
        name: 'Acesso n8n',
      },
      {
        slug: 'cpanel',
        name: 'Acesso WHM',
      },
      {
        slug: 'plesk',
        name: 'Acesso Plesk',
      },
      {
        slug: 'wordpress',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-1-clique',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-openlitespeed',
        name: 'WordPress',
      },
      {
        slug: 'docker',
        name: 'Docker',
      },
      {
        slug: 'moodle',
        name: 'Moodle',
      },
      {
        slug: 'node-js',
        name: 'Node.js',
      },
      {
        slug: 'woocommerce',
        name: 'WooCommerce',
      },
      {
        slug: 'pterodactyl',
        name: 'Pterodactyl',
      },
      {
        slug: 'laravel',
        name: 'Laravel',
      },
      {
        slug: 'cyberpanel',
        name: 'CyberPanel',
      },
      {
        slug: 'magento',
        name: 'Magento',
      },
      {
        slug: 'supabase',
        name: 'Supabase',
      },
      {
        slug: 'kubernetes-k3s',
        name: 'Kubernetes K3S',
      },
      {
        slug: 'directadmin',
        name: 'DirectAdmin',
      },
      {
        slug: 'easypanel',
        name: 'EasyPanel',
      },
      {
        slug: 'webmin',
        name: 'Webmin',
      },
      {
        slug: 'virtualmin',
        name: 'Virtualmin',
      },
      {
        slug: 'openclaw',
        name: 'OpenClaw',
      },
      {
        slug: 'gatorclaw',
        name: 'GatorClaw',
      },
      {
        slug: 'evolution-go',
        name: 'Evolution Go',
      },
      {
        slug: 'evolution-api',
        name: 'Evolution API',
      },
      {
        slug: 'evolution-crm',
        name: 'Evolution CRM',
      },
      {
        slug: 'hermes',
        name: 'Hermes Agent',
      },
      {
        slug: 'paperclip',
        name: 'Paperclip',
      },
      {
        slug: 'claude-code',
        name: 'Claude Code',
      },
    ],
  },
  serverManagement: {
    title: {
      text: 'Gerenciamento do servidor',
      tooltip: 'Execute ações administrativas da VPS, como reiniciar, recriar o servidor e gerenciar acessos SSH.',
    },
    items: {
      reboot: {
        slug: 'reboot',
        name: 'Reiniciar servidor (reboot)',
      },
      rebuild: {
        slug: 'rebuild',
        name: 'Recriar servidor (rebuild)',
      },
      sshKeys: {
        slug: 'ssh-keys',
        name: 'Gerenciar chaves SSH',
      },
    },
  },
  planDetails: {
    title: 'Detalhes do plano',
    registerDate: 'Data de contratação',
    nextDueDate: 'Vencimento em',
    billingCycle: 'Ciclo',
    paymentMethod: 'Método de pagamento',
    form: {
      title: 'Upgrade de Plano',
      defaultSelectedNeed: 'Upgrade de Plano - VPS OCI',
    },
    upgrade: {
      listing: {
        benefits: {
          title: 'Escolha o novo plano ideal para a sua VPS',
          description: 'Mais recursos, mais estabilidade e mais performance, sem interrupções no seu projeto.',
          resources: {
            title: 'Todos os planos incluem',
            items: [
              'Transferência ilimitada',
              'Servidores cloud no Brasil',
              '1 IP dedicado',
              'Migração grátis',
            ],
          },
        },
        planList: {
          prices: {
            separatorText: 'equivalente a',
            suffixText: ' /mês*',
          },
          note: '*Valor mensal aproximado, calculado apenas como referência com base no ciclo do seu plano atual. Pode variar conforme condições de pagamento e parcelamento disponíveis',
          button: 'Fazer upgrade',
          perCycle: {
            monthly: 'por mês',
            quarterly: 'por 3 meses',
            semiAnnually: 'por 6 meses',
            annually: 'por ano',
            biennially: 'por 2 anos',
            triennially: 'por 3 anos',
            oneTime: 'único',
            freeAccount: '',
          },
        },
        messages: {
          noAvailablePlans: 'Este pacote VPS não possui opções de upgrade disponíveis.',
          error: 'Não foi possível carregar as opções de upgrade no momento. Por favor, tente novamente mais tarde.',
        },
      },
      details: {
        aboutUpgrade: {
          title: 'Confirmar upgrade',
          description: 'Confira todos os detalhes e confirme o upgrade da sua VPS',
          tags: {
            current: 'Plano atual',
            target: 'Novo plano',
          },
        },
        financialSummary: {
          title: 'Resumo financeiro',
          proportionalDifference: 'Diferença proporcional',
          cycle: {
            text: 'Ciclo',
            monthly: '1 mês',
            quarterly: '3 meses',
            semiAnnually: '6 meses',
            annually: '12 meses',
            biennially: '24 meses',
            triennially: '36 meses',
            oneTime: 'único',
            freeAccount: '',
          },
          credits: {
            appliedText: 'Créditos aplicados',
          },
          coupon: {
            placeholder: 'Insira seu cupom',
            openInputButton: 'Adicionar cupom de desconto',
            discountLabel: 'Desconto do cupom',
            addButton: 'Adicionar',
            removeButton: 'Remover',
            successMessage: '',
            errorMessage: 'Cupom inválido',
          },
          vatAcronym: 'VAT',
          payment: {
            total: {
              title: 'Valor a pagar agora (pró-rata)',
              hint: days => (
                <>
                  Cálculo com base nos
                  {' '}
                  <strong>
                    {days}
                    {' '}
                    dias restantes
                  </strong>
                  {' '}
                  do seu ciclo
                </>
              ),
            },
            recurring: {
              title: 'Valor recorrente no próximo ciclo',
              hint: date => `Próxima renovação em ${date}`,
            },
          },
        },
        informations: {
          title: 'Informações importantes',
          description: (
            <ul>
              <li>O upgrade não altera o ciclo de faturamento nem a data de vencimento da sua VPS.</li>
              <li>Na próxima renovação, sua VPS será cobrada com os novos valores integrais do ciclo vigente.</li>
              <li>O upgrade será realizado apenas após a confirmação do pagamento.</li>
              <li>Durante o provisionamento, sua VPS pode ficar temporariamente indisponível, sem risco de perda de dados e sem impacto em painéis ou aplicações adicionadas à VPS.</li>
            </ul>
          ),
        },
        checkboxConfirmation: 'Entendo que esta ação é definitiva e que não será possível fazer downgrade posteriormente.',
        buttons: {
          cancel: 'Desistir do upgrade',
          confirm: 'Confirmar e ir para pagamento',
        },
        messages: {
          error: 'Não foi possível processar seu pedido de upgrade no momento. Por favor, tente novamente mais tarde.',
        },
      },
      resources: {
        suffix: {
          processor: '',
          memory: 'de RAM DDR5',
          disk: 'de armazenamento NVMe',
        },
      },
      alert: {
        title: 'Há uma solicitação de upgrade em andamento para este servidor',
        description: 'Efetue o pagamento da fatura em aberto. Se já foi realizado, aguarde a conclusão do upgrade para realizar uma nova alteração.',
        action: 'Ver faturas',
      },
      backButton: 'Voltar',
      button: 'Fazer upgrade',
    },
    upgradeNew: {
      listing: {
        header: {
          title: 'Leve seu servidor VPS para o próximo nível',
          description: 'Mais recursos para acompanhar seu crescimento',
        },
        periodSelector: {
          title: 'Escolha a periodicidade',
          currentCycleLabel: 'Ciclo atual',
          bestValueLabel: 'Mais vantajoso',
          savingsBannerText: {
            current: 'Você pode economizar mais com um período maior.',
            middle: 'Períodos com mais tempo oferecem ainda mais desconto.',
            penultimate: 'Quer economizar mais? Aumente o período e chegue à economia máxima!',
            last: 'Máxima economia garantida.',
          },
          cycles: {
            monthly: '1 mês',
            quarterly: '3 meses',
            semiAnnually: '6 meses',
            annually: '1 ano',
            biennially: '2 anos',
            triennially: '3 anos',
          },
        },
        planList: {
          title: 'Escolha seu próximo plano',
          currentPlanLabel: 'Seu plano atual',
          recommendedLabel: 'Recomendado para você',
          prices: {
            separatorText: 'equivalente a',
            suffixText: ' /mês*',
          },
          button: 'Selecionar plano',
          resources: {
            suffix: {
              processor: '',
              memory: 'de RAM DDR5',
              disk: 'de NVMe',
            },
          },
          perCycle: {
            monthly: 'por 1 mês',
            quarterly: 'por 3 meses',
            semiAnnually: 'por 6 meses',
            annually: 'por 1 ano',
            biennially: 'por 2 anos',
            triennially: 'por 3 anos',
          },
          errorMessages: {
            noFetch: 'Não foi possível carregar as opções de upgrade no momento. Por favor, tente novamente.',
            tryAgainButton: 'Tentar novamente',
          },
        },
        performanceBanner: {
          title: 'Precisa de ainda mais performance?',
          descriptionPrefix: 'Conheça os ',
          descriptionBold: 'servidores dedicados',
          descriptionSuffix: ' e tenha recursos 100% exclusivos com performance avançada para aplicações com alto consumo de CPU ou projetos em grande escala.',
          button: 'Saber mais',
        },
        features: {
          title: 'Todos os planos de Servidor VPS incluem',
          groups: {
            infrastructure: 'Infraestrutura',
            performance: 'Performance',
            control: 'Controle',
          },
          items: {
            unlimitedTransfer: {
              title: 'Transferência ilimitada',
              description: 'Sem limites de tráfego para seu site ou aplicação crescer com liberdade.',
            },
            cloudServers: {
              title: 'Servidores cloud no Brasil',
              description: 'Infraestrutura localizada no Brasil para menor latência e melhor performance.',
            },
            dedicatedIp: {
              title: '1 IP dedicado',
              description: 'Mais controle, segurança e reputação para seu servidor.',
            },
            nvmeStorage: {
              title: 'Armazenamento com discos NVMe',
              description: 'Leitura e escrita muito mais rápidas para aplicações exigentes.',
            },
            amdEpyc: {
              title: 'Processadores AMD EPYC',
              description: 'Alta performance e estabilidade para cargas de trabalho intensas.',
            },
            ddr5Memory: {
              title: 'Memória RAM DDR5',
              description: 'Mais velocidade e eficiência para rodar aplicações modernas.',
            },
            rootAccess: {
              title: 'Mais poder e controle com acesso root',
              description: 'Controle total do servidor para instalar e configurar o que quiser.',
            },
            freeMigration: {
              title: 'Migração grátis',
              description: 'Nossa equipe ajuda você a migrar seu projeto sem complicações.',
            },
          },
        },
      },
    },
  },
  vpsCustomizer: {
    hireBanner: {
      title: 'Crie, teste e escale seus projetos',
      description: 'Personalize sua VPS instalando painéis ou aplicações conforme suas necessidades.',
      button: 'Explorar painéis e aplicações',
    },
    form: {
      title: 'Alteração de Plano',
      defaultSelectedNeed: 'Alteração de Plano',
    },
  },
  helpLinks: {
    helpCenterButton: 'Acessar central de ajuda',
    tourButton: 'Ver tour guiado novamente',
  },
  welcomeModal: {
    title: 'Boas-vindas à sua VPS HostGator!',
    description: (
      <>
        <p>Que bom ter você por aqui!</p>
        <p>Este é o painel onde você gerencia seu servidor e deixa tudo do seu jeito. Aqui, você pode instalar aplicações, painéis de controle ou automações. </p>
        <p>Agora, vou te mostrar onde encontrar as principais informações e funcionalidades da sua VPS.</p>
      </>
    ),
    buttonLabel: 'Iniciar tour guiado',
  },
  guidedTour: {
    stepIndicator: (current, total) => `${current} de ${total}`,
    nextButton: 'Próximo',
    finishButton: 'Finalizar',
    steps: [
      {
        title: 'Sua nova VPS',
        description: 'Aqui você visualiza e controla o estado do seu servidor e também pode reiniciar quando precisar.',
      },
      {
        title: 'Dados principais da sua VPS',
        description: (
          <>
            <p>
              Tudo o que identifica o seu servidor. Em breve, você conseguirá monitorar o desempenho da sua VPS por aqui.
            </p>
            <p>
              <strong>Dica:</strong>
              {' '}
              o ícone ⓘ ao lado dos títulos traz mais detalhes sempre que precisar.
            </p>
          </>
        ),
      },
      {
        title: 'Acesso direto ao servidor',
        description: 'Copie essas informações pra se conectar via SSH pelo terminal da sua preferência. É o caminho pra acessar diretamente o ambiente da sua VPS.',
      },
      {
        title: 'Ferramentas do dia a dia',
        description: 'Aqui você gerencia o sistema operacional e acessa painéis ou aplicações que estão adicionados na sua VPS.',
      },
    ],
  },
  openClaw: {
    confirmationTokenPage: {
      title: 'Configurar OpenClaw',
      description: (
        <>
          <span>Boas-vindas!</span>
          <span>Para que o OpenClaw funcione na sua VPS, informe as chaves de acesso dos serviços de IA. Elas permitem que o agente de IA se conecte e execute tarefas automaticamente.</span>
        </>
      ),
      inputs: {
        openai: {
          placeholder: {
            desktop: 'Chave de API OpenAI (OPENAI_API_KEY)',
            mobile: 'Chave de API OpenAI',
          },
          hint: 'Chave de API da OpenAI para utilizar modelos de IA (obtenha em platform.openai.com).',
        },
      },
      observation: 'Suas chaves são usadas apenas para autenticação e ficam armazenadas de forma segura no seu ambiente.',
      buttons: {
        manualSetupLater: 'Configurar manualmente depois',
        confirm: 'Configurar OpenClaw',
      },
      modal: {
        title: 'Configurar manualmente depois',
        description: (
          <>
            <span>
              Os tokens são necessários para que o OpenClaw execute automações com IA.
            </span>
            <span>
              Você pode configurar manualmente mais tarde via terminal da VPS. Porém,
              {' '}
              <strong>essa opção exige conhecimento técnico e configuração por linha de comando.</strong>
            </span>
            <span>
              Recomendamos concluir a configuração agora para ativar o agente de forma simples.
            </span>
          </>
        ),
        buttons: {
          manualSetupLater: 'Continuar sem configurar',
          configureNow: 'Configurar agora',
        },
      },
      messages: {
        success: 'A chave de API informada foi configurada no OpenClaw',
        error: 'Erro ao tentar configurar o OpenClaw. Tente novamente.',
      },
    },
  },
  gatorClaw: {
    configurationPage: {
      title: 'Vamos configurar seu GatorClaw',
      description: 'Para usar o GatorClaw na VPS, você precisa realizar a configuração inicial, é bem fácil e rápido.',
      terms: {
        prefix: 'Ao continuar você aceita os ',
        linkText: 'termos de uso',
        suffix: ' do GatorClaw.',
      },
      buttons: {
        configure: 'Configurar GatorClaw',
      },
      logoAlt: 'GatorClaw Logo',
      termsLinkUrl: 'https://suporte.hostgator.com.br/hc/pt-br/articles/49551572161555-Termos-de-Uso-do-GatorClaw',
    },
  },
  sshKeys: {
    management: {
      title: 'Gerenciar chaves SSH',
      description: 'As chaves SSH permitem acesso root sem senha, oferecendo maior segurança para sua VPS. Cada chave adicionada é sincronizada automaticamente com o servidor.',
      backButton: 'Voltar',
      createKeyButton: 'Adicionar chave',
      list: {
        title: 'Chaves ativas',
        sshKeysCount: (current, maxKeys) => `${current} de ${maxKeys}`,
        item: {
          createdAt: (date, isMobile) => (isMobile ? `${date}` : `Adicionada em ${date}`),
          buttons: {
            copy: 'Copiar',
            delete: 'Excluir',
          },
        },
        limitMaxReached: 'Você tem cinco chaves adicionadas ativas. Para adicionar uma nova, exclua uma chave existente.',
        fallbacks: {
          empty: {
            title: 'Nenhuma chave SSH adicionada',
            description: 'Adicione sua primeira chave SSH para começar a gerenciar os acessos.',
            createKeyButton: 'Adicionar chave',
          },
          error: {
            title: 'Não foi possível carregar as chaves SSH',
            description: 'Atualize a página ou tente novamente mais tarde.',
            refreshPageButton: 'Atualizar página',
          },
        },
      },
      modal: {
        createKey: {
          title: 'Adicionar chave SSH',
          inputs: {
            name: {
              label: 'Nome da chave',
              placeholder: 'Insira um nome para a chave',
              helpText: 'Um nome descritivo para identificar esta chave. Até 50 caracteres no máximo.',
              errorMessage: 'O nome da chave é obrigatório e deve ter no máximo 50 caracteres.',
            },
            key: {
              label: 'Chave pública',
              placeholder: 'Insira a chave gerada',
              errors: {
                invalidFormat: 'Formato de chave inválido',
                alreadyExists: 'Essa chave já está cadastrada',
              },
            },
          },
          alert: 'Não tem uma chave? Aprenda como gerar uma chave SSH.',
          buttons: {
            cancel: 'Cancelar',
            create: 'Adicionar chave',
          },
          messages: {
            success: 'Nova chave adicionada',
            error: 'Não foi possível adicionar a chave. Tente novamente mais tarde.',
            missingFields: 'Preencha todos os campos obrigatórios.',
            forbiddenError: 'Você não tem permissão para adicionar esta chave.',
            alreadyExists: 'Essa chave já foi adicionada.',
          },
        },
        deleteKey: {
          title: 'Remover chave SSH',
          description: keyName => (
            <>
              <div>
                Tem certeza de que deseja remover a chave SSH
                {' '}
                <strong>{keyName}</strong>
                ?
              </div>

              <div>
                Essa ação não afeta sessões ativas, apenas novos acessos ao servidor.
              </div>
            </>
          ),
          buttons: {
            cancel: 'Cancelar',
            delete: 'Remover chave',
          },
          messages: {
            success: keyName => `${keyName} excluída!`,
            error: keyName => `${keyName} não pôde ser excluída. Tente novamente.`,
            missingFields: 'Preencha todos os campos obrigatórios.',
            forbiddenError: 'Você não tem permissão para excluir esta chave.',
            keyNotFound: 'Chave não encontrada.',
          },
        },
      },
    },
  },
  store: {
    details: {
      title: 'Sistemas operacionais e aplicações',
      description: 'Os Sistemas Operacionais e Aplicações definem como sua VPS funciona e o que ela pode fazer. Escolha e solicite a instalação ou reinstalação conforme suas necessidades.',
      operationalSystems: {
        almalinux: {
          name: 'AlmaLinux',
          description: 'Alternativa gratuita ao RHEL, com foco em estabilidade, desempenho e compatibilidade para ambientes empresariais.',
        },
        ubuntu: {
          name: 'Ubuntu',
          description: 'Distribuição Linux baseada no Debian, gratuita e fácil de usar, com suporte de longo prazo e foco em estabilidade e segurança.',
        },
        debian: {
          name: 'Debian',
          description: 'Sistema Linux estável e seguro, ideal para servidores e ambientes críticos, com pacotes atualizados e suporte de comunidade.',
        },
        rockylinux: {
          name: 'Rocky Linux',
          description: 'Distribuição compatível com RHEL, voltada para uso corporativo, oferecendo alto desempenho, segurança e confiabilidade.',
        },
      },
      panels: {
        cpanel: {
          name: 'cPanel',
          description: 'Painel intuitivo e completo para gerenciamento de sites e servidores, ideal para hospedagens com foco em desempenho e automação.',
        },
        plesk: {
          name: 'Plesk',
          description: 'Painel moderno e fácil de usar, permite gerenciar sites, domínios e e-mails com praticidade, integrando recursos de segurança e backups.',
        },
        cyberpanel: {
          name: 'CyberPanel',
          description: 'Distribuição Linux baseada no Debian, gratuita e fácil de usar, com suporte de longo prazo e foco em estabilidade e segurança.',
        },
        webmin: {
          name: 'Webmin',
          description: 'Painel de administração baseado na web, versátil e personalizável, ideal para quem busca controle total do servidor Linux.',
        },
        easypanel: {
          name: 'EasyPanel',
          description: 'Painel leve e intuitivo, voltado para usuários que desejam simplicidade no gerenciamento de servidores e sites.',
        },
        virtualmin: {
          name: 'Virtualmin',
          description: 'Painel completo e flexível, voltado para usuários que precisam de controle avançado no gerenciamento de servidores, domínios, e serviços integrados.',
        },
      },
      applications: {
        n8n: {
          name: 'n8n',
          description: 'Ferramenta de automação pronta para uso, permite criar fluxos e integrações entre sistemas sem código.',
        },
        'wordpress-1-clique': {
          name: 'WordPress 1-clique',
          description: 'Instalação rápida e automática do WordPress, ideal para criar sites e blogs em poucos minutos.',
        },
        'wordpress-openlitespeed': {
          name: 'WordPress otimizado com LiteSpeed/OLS',
          description: 'Versão ajustada para máximo desempenho e velocidade, com cache LiteSpeed nativo e alta eficiência.',
        },
        docker: {
          name: 'Docker',
          description: 'Plataforma que empacota aplicações e seus ambientes em contêineres, garantindo portabilidade e execução consistente em qualquer servidor.',
        },
        'node-js': {
          name: 'Node.js',
          description: 'Ambiente que permite rodar JavaScript no servidor para criar APIs e aplicações rápidas e leves, ideal para desenvolvedores e projetos modernos.',
        },
        moodle: {
          name: 'Moodle',
          description: 'Plataforma educacional open source, perfeita para criar e gerenciar cursos e ambientes de aprendizado online.',
        },
        pterodactyl: {
          name: 'Pterodactyl',
          description: 'Painel de gerenciamento de servidores de jogos, seguro e simples, voltado para hospedagem de games.',
        },
        magento: {
          name: 'Magento',
          description: 'Plataforma de e-commerce, otimizada para performance e escalabilidade em grandes lojas online.',
        },
        supabase: {
          name: 'Supabase',
          description: 'Backend open source completo com autenticação, banco de dados e API, alternativa moderna ao Firebase.',
        },
        laravel: {
          name: 'Laravel',
          description: 'Framework PHP elegante e produtivo, ideal para desenvolvimento rápido de aplicações web seguras.',
        },
        'kubernetes-k3s': {
          name: 'Kubernetes K3S',
          description: 'Sistema de orquestração de containers que automatiza implantação, escalabilidade e gerenciamento de aplicações.',
        },
        woocommerce: {
          name: 'WooCommerce',
          description: 'Plataforma de e-commerce flexível e personalizável, baseada em WordPress, ideal para lojas online de pequeno a grande porte, com ampla variedade de plugins, temas e integrações.',
        },
        openclaw: {
          name: 'OpenClaw',
          description: 'Agente de IA flexível e personalizável, de código aberto, executado em VPS, com memória persistente, integrações e atuação autônoma em nome do usuário.',
        },
        gatorclaw: {
          name: 'GatorClaw',
          description: 'Com o GatorClaw, você usa todo o poder do OpenClaw em uma interface visual amigável e intuitiva desenvolvida pela HostGator para facilitar sua jornada com IA.',
        },
        'evolution-go': {
          name: 'Evolution Go',
          description: 'Com o Evolution Go, você executa automações completas de WhatsApp em um VPS otimizado, integrando APIs, chatbots com IA, notificações e workflows entre sistemas de forma simples e escalável.',
        },
        'evolution-api': {
          name: 'Evolution API',
          description: 'Automatize e integre o WhatsApp com facilidade em um VPS otimizado. Conecte chatbots, IA e sistemas externos com integrações nativas e suporte à API Oficial da Meta.',
        },
        'evolution-crm': {
          name: 'Evolution CRM',
          description: 'Com a Evo CRM, você automatiza seu atendimento com agentes de IA, organiza conversas e gerencia seus clientes e suas vendas em uma única plataforma.',
        },
        hermes: {
          name: 'Hermes Agent',
          description: 'Execute tarefas, automatize processos e desenvolva fluxos com um agente de IA autoevolutivo, com memória persistente, integração com ferramentas e operação contínua em sua própria infraestrutura.',
        },
        paperclip: {
          name: 'Paperclip',
          description: 'Estruture e orquestre agentes de IA que operam como equipes, com papéis, metas, tarefas e controle de execução em uma infraestrutura centralizada.',
        },
        'claude-code': {
          name: 'Claude Code',
          description: 'Desenvolva, revise e automatize código com IA avançada, acelerando o desenvolvimento e elevando a qualidade das entregas.',
        },
      },
    },
    currentSo: {
      title: 'Sistema operacional atual',
      addons: {
        title: 'Adicionado no seu Sistema Operacional',
        application: 'Aplicação',
      },
    },
    changeApplications: {
      title: 'Alterar sistema operacional ou aplicação',
      description: 'No momento, para alterar o sistema operacional do seu VPS, é necessário abrir um chamado com o time de suporte. Selecione o sistema desejado para ser redirecionado ao formulário de abertura.',
      tabs: {
        operationalSystems: 'SO Simples',
        panels: 'SO com Painel',
        applications: 'Aplicação',
      },
      modal: {
        operationalSystems: {
          title: 'Alterar sistema operacional',
          placeholder: {
            versions: 'Selecionar versão',
          },
          withoutSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          withSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (
              <>
                Ao instalar um novo sistema operacional,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: [
              {
                text: 'Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional.',
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
          confirmWithPanelPaidActive: {
            message: (formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (so = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{so}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
        },
        panels: {
          title: 'Instalar sistema operacional com painel',
          placeholder: {
            optionsAccounts: 'Opções de contas',
            paymentFrequency: 'Periodicidade de pagamento',
          },
          qtyAccountsText: seats => `Até ${seats} contas`,
          qtyAccountsTextUnlimited: 'Contas ilimitadas',
          provisioned: so => (
            <>
              Painel provisionado em
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionPanels: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (panel = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: (panel = []) => [
              {
                text: (
                  <>
                    Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{panel}</strong>
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entendo que a instalação somente será realizada após a compensação do pagamento, e que o prazo pode variar de acordo com o método escolhido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Voltar',
            confirmButtonPayment: 'Ir para pagamento',
            confirmButtonInstall: 'Instalar agora',
          },
          confirmWithPanelPaidActive: {
            message: (panel = '', formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (panel = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{panel}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entendo que a instalação somente será realizada após a compensação do pagamento, e que o prazo pode variar de acordo com o método escolhido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Voltar',
            confirmButtonPayment: 'Ir para pagamento',
            confirmButtonInstall: 'Instalar agora',
          },
        },
        applications: {
          title: 'Instalar sistema operacional com aplicação',
          provisioned: so => (
            <>
              Aplicação provisionada em
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionApplication: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          selectionDomain: {
            message: 'Essa aplicação precisa de um domínio para funcionar corretamente. Escolha como você quer seguir.',
            closeButton: 'Voltar',
            confirmButton: 'Continuar',
            alreadyHasDomain: {
              label: 'Usar um domínio que já possuo',
              input: {
                label: 'Insira seu domínio',
                helpText: '(ex.: seudominio.com.br)',
                errorMessage: 'Insira um domínio válido.',
              },
            },
            needToRegisterDomain: {
              label: 'Registrar um novo domínio',
              description: (
                <>
                  <p>Não tem um domínio ainda? Você pode registrar um agora. Você será direcionado para a contratação de domínio e a instalação da aplicação será interrompida.</p>
                  <p>Depois de registrar o domínio, volte para a seleção de aplicações e inicie a instalação novamente usando o domínio comprado.</p>
                </>
              ),
            },
          },
          confirmWithoutPanelPaidActive: {
            message: (application = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: (application = '') => (
              [
                {
                  text: (
                    <>
                      Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional com
                      {' '}
                      <strong>{application}</strong>
                      .
                    </>
                  ),
                  id: 'beDeleted',
                },
              ]
            ),
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
          confirmWithPanelPaidActive: {
            message: (application = '', formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (application = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{application}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
        },
      },
    },
    rebuild: {
      title: 'Rebuild (reinstalação)',
      description: 'O rebuild recria o seu VPS do zero usando o mesmo sistema operacional. Serve pra restaurar o ambiente original e corrigir possíveis erros de configuração ou desempenho.',
      button: 'Fazer rebuild agora',
      modal: {
        confirmRebuild: {
          title: 'Rebuild VPS',
          message: (
            <>
              Ao realizar o rebuild, sua VPS será recriada do zero
              {' '}
              <strong>com o mesmo Sistema Operacional</strong>
              . Todos os dados e configurações serão apagados de forma irreversível.
            </>
          ),
          agreedTerms: [
            {
              text: 'Estou ciente de que tudo será apagado de forma permanente para a reinstalação do sistema operacional.',
              id: 'beDeleted',
            },
          ],
          closeButton: 'Cancelar',
          confirmButton: 'Fazer rebuild',
        },
        serverInactive: {
          title: 'VPS não disponível',
          message: 'A VPS não está pronta para uso ainda. Aguarde o provisionamento finalizar.',
          confirmButton: 'Entendi',
        },
        limitExceeded: {
          title: 'Limite diário de rebuilds atingido',
          message: (
            <>
              Você atingiu o
              {' '}
              <strong>limite de dois rebuilds</strong>
              {' '}
              (reinstalações do sistema operacional, seja o atual ou um novo) nas últimas 24 horas. Será possível realizar um novo amanhã.
            </>
          ),
          confirmButton: 'Entendi',
        },
        notFound: {
          title: 'Sua VPS está offline',
          message: 'A VPS está inativa no momento. Ative-a para continuar.',
          confirmButton: 'Entendi',
        },
        unknownError: {
          title: 'Rebuild não concluído',
          message: 'Não foi possível concluir o rebuild da sua VPS. Tente novamente em alguns instantes.',
          closeButton: 'Fechar',
          confirmButton: 'Tentar novamente',
        },
      },
      feedback: {
        request: {
          title: 'Estamos preparando o rebuild da sua VPS',
          description: 'Sua solicitação foi confirmada e está sendo preparada. Em instantes, o rebuild da VPS será iniciado automaticamente.',
        },
        loading: 'Rebuild em progresso. Isso pode levar alguns minutos. Aguarde...',
      },
    },
    modal: {
      alert: {
        backup: {
          title: 'Essa ação não poderá ser desfeita!',
          message: 'Antes de continuar, faça backup de todos os seus arquivos e informações importantes.',
          backup: {
            text: 'Saiba como fazer backup.',
            link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000385173',
          },
        },
      },
    },
  },
  form: {
    changePlan: {
      title: 'Alteração de plano',
      defaultSelectedNeed: 'Alteração de Plano',
    },
  },
  messages: {
    vpsNotFound: 'VPS não encontrada. Por favor, verifique se o serviço está ativo ou entre em contato com o suporte.',
  },
};

const advancedHosting = {
  header: {
    title: 'VPS e Dedicados',
    searchInput: {
      placeholder: 'Pesquisar servidor',
    },
    buttons: {
      newServer: 'Novo servidor',
    },
  },
  serverList: {
    columnsLabel: {
      details: 'Detalhes do servidor',
      addressIp: 'Endereço IP',
      status: 'Status do servidor',
      quickAccess: 'Acesso rápido',
      setServerNickname: 'Definir apelido do servidor',
    },
    buttons: {
      management: 'Gerenciar',
    },
    tooltip: {
      console: 'Abrir console',
      favorite: 'Favoritar',
    },
    alertMessages: {
      activateServer: 'Ative o seu servidor.',
      reactiveServer: 'Reative seu servidor.',
      paymentPending: 'Finalize o pagamento e comece a usar.',
      serverBuilding: 'Seu servidor está sendo configurado. Aguarde até ser liberado para uso.',
    },
  },
  emptyState: {
    title: 'Nenhum servidor ainda',
    subtitle: 'Você ainda não criou nenhum servidor. Escolha um tipo para contratar e começar a rodar seus projetos',
    selector: {
      vps: {
        title: 'Servidor VPS',
        description: 'Alto desempenho para rodar seus projetos com liberdade total',
        button: 'Contratar VPS',
      },
      dedicated: {
        title: 'Servidor Dedicado',
        description: 'Planos com recursos dedicados para impulsionar seu projeto.',
        button: 'Contratar Dedicado',
      },
    },
  },
  serverTypeModal: {
    title: 'Que tipo de servidor você precisa?',
    subtitle: 'Escolha para ver os planos disponíveis:',
    selector: {
      vps: {
        title: 'Servidor VPS',
        description: 'Alto desempenho para rodar seus projetos com liberdade total.',
        button: 'Contratar VPS',
      },
      dedicated: {
        title: 'Servidor Dedicado',
        description: 'Planos com recursos dedicados para impulsionar seu projeto.',
        button: 'Contratar Dedicado',
      },
    },
  },
  noSearchResult: {
    title: 'Nenhum servidor encontrado',
    subtitle: 'Tente outra busca ou explore os servidores disponíveis',
  },
};

const cpanel = {
  genericErrorTitle: 'Ops, algo deu errado',
  genericErrorDescription: 'Não foi possível acessar o cPanel. Tente novamente mais tarde.',
};

export default { vpsOci, advancedHosting, cpanel };
